package vip.cdms.orecompose.style

import androidx.compose.ui.graphics.Color
import vip.cdms.orecompose.utils.rgb

object OreColors {
    val PureWhite = Color.White
    val PureBlack = Color.Black

    val Outline = 0x1E1E1F.rgb
    val OutlineDisabled = 0x8C8D90.rgb
}
